import React from "react";

import { Box, useMediaQuery } from "@mui/material";

import BarsChart from "../../../../components/BarsChart/BarsChart";

const BoxDistributionAccessDayOfWeek = ({ data }) => {
  const isMobile = useMediaQuery("(max-width:600px)");

  const parsedDataset = Object.entries(data).map(([day, avg_access]) => ({
    day: day,
    avg_access: Number(avg_access),
  }));

  return (
    <Box
      sx={{
        justifyContent: "center",
        alignSelf: "center",
      }}
    >
      <BarsChart
        dataset={parsedDataset}
        yDataKey="avg_access"
        yScaleType="linear"
        xScaleType="band"
        xDataKey="day"
        height={300}
        width={isMobile ? 240 : 350}
        layout="vertical"
        series={[
          {
            dataKey: "avg_access",
            label: "Accessi medi",
            valueFormatter: (value) => `${value}`,
            color: "rgb(218, 0, 255)",
          },
        ]}
      />
    </Box>
  );
};

export default BoxDistributionAccessDayOfWeek;
